import mailchimpIcon from '../images/marquee/mailchimp.svg'
import wordpressIcon from '../images/marquee/wordpress.svg'
import sitescoreIcon from '../images/marquee/sitescore.svg'
import webflowIcon from '../images/marquee/webflow.svg'
import elementorIcon from '../images/marquee/elementor.svg'
import goDaddyIcon from '../images/marquee/go-daddy.svg'
import squareSpaceIcon from '../images/marquee/square-space.svg'
import shopifyIcon from '../images/marquee/shopify.svg'
import wixIcon from '../images/marquee/wix.svg'
import figmaIcon from '../images/marquee/figma.svg'

export const brands = [
    {
        title: 'MailChimp',
        icon: mailchimpIcon
    },
    {
        title: 'WordPress',
        icon: wordpressIcon
    },
    {
        title: 'Sitecore',
        icon: sitescoreIcon
    },
    {
        title: 'Webflow',
        icon: webflowIcon
    },
    {
        title: 'Elementor',
        icon: elementorIcon
    },
    {
        title: 'GoDaddy',
        icon: goDaddyIcon
    },
    {
        title: 'Squarespace',
        icon: squareSpaceIcon
    },
    {
        title: 'Shopify',
        icon: shopifyIcon
    },
    {
        title: 'Wix',
        icon: wixIcon
    },
    {
        title: 'Figma',
        icon: figmaIcon
    }
]